/* page refresh everytime a product leave or enter allocation validation
  Added by Wilson from Galadrim
   ─────────────────────────────────────────────────────────── */

(() => {
  if (window.__allocWatchdogPatched) return;
  window.__allocWatchdogPatched = true;

  const allocDataNode = document.querySelector("[data-cart-items-allocation-data]");
  if (!allocDataNode) return;

  let itemsAllocationData;
  try {
    itemsAllocationData = JSON.parse(allocDataNode.textContent);
  } catch (e) {
    return;
  }

  if (!Array.isArray(itemsAllocationData)) return;

  const itemsAllocMap = new Map(itemsAllocationData.map(item => [item.key, item]));

  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const [input, opts] = args;

    const url = typeof input === "string" ? input : input.url;

    if (!/\/cart\/change\.js/.test(url)) {
      return origFetch.apply(this, args);
    }

    if (opts && opts.body) {
      try {
        const bodyData =
          opts.body instanceof FormData ? Object.fromEntries(opts.body.entries()) : JSON.parse(opts.body);
        let lineKey = bodyData.id || null;
        const lineIndex = bodyData.line || null;
        const newQuantity = parseInt(bodyData.quantity, 10);

        if (!lineKey && lineIndex) {
          const itemEl = document.querySelector(`.cartitems [data-line-index="${lineIndex}"]`);
          if (itemEl) {
            lineKey = itemEl.dataset.cartItemKey;
          }
        }

        if (lineKey && !isNaN(newQuantity)) {
          const itemAllocData = itemsAllocMap.get(lineKey);

          if (itemAllocData && itemAllocData.is_under_allocation) {
            const cartItemContainer = document.querySelector(`[data-cart-item-key="${lineKey}"]`);
            if (!cartItemContainer) return origFetch.apply(this, args);

            const currentIsInValidation = !!cartItemContainer.closest(".allocated-products-section");
            const nextIsInValidation = newQuantity > itemAllocData.allocated_quantity;

            if (currentIsInValidation !== nextIsInValidation) {
              const p = origFetch.apply(this, args);
              p.finally(() => location.reload());
              return p;
            }
          }
        }
      } catch (e) {
        // Ignore parsing errors
      }
    }

    return origFetch.apply(this, args);
  };
})();
